<template>
  <div class="width-100">
    <h2 class="section-title">{{ $t('tasks.title') }}</h2>
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'Tasks',
  };
</script>
